import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

import FieldsetGroup from 'src/components/shared/ui/form/fields/FieldsetGroup/FieldsetGroup'
import OrigenCautelar from 'src/components/views/EscritosLexnet/components/IniciadorAsunto/components/Origen/components/OrigenCautelar/OrigenCautelar'
import OrganoOrigen from 'src/components/views/EscritosLexnet/components/IniciadorEjecucion/components/Origen/components/OrganoOrigen/OrganoOrigen'
import NIG from 'src/components/views/EscritosLexnet/components/shared/components/NIG/NIG'
import Procedimiento from 'src/components/views/EscritosLexnet/components/shared/components/Procedimiento/Procedimiento'
import { EscritosFormValues } from 'src/components/views/EscritosLexnet/components/shared/types/escritosFormTypes'
import { FormField } from 'src/enums/Form'

function Origen(): JSX.Element {
  const { t } = useTranslation()
  const { values } = useFormikContext<EscritosFormValues>()
  const organoDestinoDeTipoJudicial = values[FormField.ORGANO_DESTINO_DE_TITULO_JUDICIAL]

  function showFieldsDependingOnDeTipoJudicial() {
    return organoDestinoDeTipoJudicial === null || organoDestinoDeTipoJudicial === true
  }

  return (
    <FieldsetGroup legend={t('form.legend.origen')}>
      <OrigenCautelar />
      {showFieldsDependingOnDeTipoJudicial() && (
        <>
          <OrganoOrigen />
          <Procedimiento />
          <NIG />
        </>
      )}
    </FieldsetGroup>
  )
}

export default Origen
